import { render, staticRenderFns } from "./Aplicacion.vue?vue&type=template&id=b9e23876&scoped=true"
import script from "./Aplicacion.vue?vue&type=script&lang=js"
export * from "./Aplicacion.vue?vue&type=script&lang=js"
import style0 from "./Aplicacion.vue?vue&type=style&index=0&id=b9e23876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e23876",
  null
  
)

export default component.exports